import React from "react";
import Plans from "../component/plan/Plans";
import SearchSection from "../component/search/SearchSection";
import AboutUs from "../component/aboutUs/AboutUs";
import { Helmet } from "react-helmet";
import WelcomeModal from "../component/common/WelcomeModal";
import welcomeimage from '../assets/welcome-image.webp';
import playstore from '../assets/googleplay.webp';
import appstore from '../assets/appstore.webp';


const HomePage =()=>{

    return(
        <div className="main_content">
            <Helmet>
            <link rel="canonical" href="/"/>
            <link rel="preload" href="https://fonts.gstatic.com/s/mulish/v17/1Ptvg83HX_SGhgqk3wot.woff2" as="font" type="font/woff2"
            crossorigin="anonymous"/>
            <link rel="preload"
            href="https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap"
            as="style" type="font/woff2" crossorigin="anonymous"/>
            <link rel="preload" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" as="style" />

            <title>Truck & Trailer Repair Services | Online Road Services</title>
            <meta name="keywords" content="trailer repair shops, truck and trailer repair, truck repair near me, truck repair shops near me, semi trailer repair shop"/>
            <meta name="description" content="Get expert truck and trailer repair services with 24/7 roadside assistance. Fast &reliable support to keep you on the road. Call Online Road Services now!" />
            <meta property="og:title" content="Truck & Trailer Repair Services | Online Road Services" />
            <meta property="og:description" content="Get expert truck and trailer repair services with 24/7 roadside assistance. Fast &reliable support to keep you on the road. Call Online Road Services now!" />
            <link rel="preload" as="image" href={welcomeimage}/>
            <link rel="preload" as="image" href={appstore}/>
            <link rel="preload" as="image" href={playstore}/>

           </Helmet>

            <WelcomeModal/>
            <SearchSection/>
            <AboutUs/>
            <Plans/>
        </div>
    );
};

export default HomePage;